import { SimpleInfoList as AntdSimpleInfoList } from "@empglabs/backoffice-ui-kit"

const SimpleInfoList = props => {
  return <AntdSimpleInfoList {...props} />
}

export default SimpleInfoList
